import NiceModal from '@ebay/nice-modal-react'

import DeleteModal from 'components/DeleteModal'
import ConfirmModal from 'components/ConfirmModal'

import UsersAddCompanyModal from 'components/users/AddCompanyModal'
import UsersAddUserModal from 'components/users/AddUserModal'
import UsersEditUserModal from 'components/users/EditUserModal'

NiceModal.register('deleteModal', DeleteModal)
NiceModal.register('confirmModal', ConfirmModal)

NiceModal.register('usersAddCompanyModal', UsersAddCompanyModal)
NiceModal.register('usersAddUserModal', UsersAddUserModal)
NiceModal.register('usersEditUserModal', UsersEditUserModal)